import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { Dropdown } from 'semantic-ui-react';

import '../../css/reports/ReportDropdown.less';

import { SatCoreRegister } from '../../SatCoreRegistry';

import { getSessionStorageItem } from '../../utils';

import { REPORT_FAILURE_BEHAVIOR_TYPE } from '../../services/reports/ReportConstants';

import ReportIdentityService from '../../services/reports/ReportIdentityService';
import ReportJsonHelperService from '../../services/reports/ReportJsonHelperService';
import ReportTableService from '../../services/reports/ReportTableService';
import ReportTypeService from '../../services/reports/ReportTypeService';

const ReportCourseDropdown = observer((props) => {
  const { t } = props;

  const {
    reportCourseManager,
    reportIdentityManager,
    reportOverrideManager,
    reportTableManager,
    reportTypeManager
  } = useContext(MobXProviderContext);

  /** equivalent to componentDidMount(), i.e. only called after initial render */
  useEffect(() => {
    (async () => {
      reportCourseManager.setSelectedReportCourseInfo(
        getSessionStorageItem('selectedReportCourseContentItemId'), {
          courseName: getSessionStorageItem('selectedReportCourseName'),
          courseResourceId: getSessionStorageItem('selectedReportCourseResourceId')
        }
      );
    })();
  }, []);

  const handleChangeReportCourseDropdown = async (_event, data) => {
    if (reportOverrideManager.shouldExpandAllReportTableRowsByDefault) {
      reportTableManager.clearExpandedReportTableRows();
    }

    const { reportCourseNamesByInstitutionMap } = reportCourseManager;

    const courseContentItemId = data.value;
    const courseObj = reportCourseNamesByInstitutionMap.get(courseContentItemId);

    reportCourseManager.setSelectedReportCourseInfo(courseContentItemId, courseObj);

    if (reportIdentityManager.isStandardsReport) {
      const { activeReportType, activeReportFacultyType } = reportIdentityManager;
      const { selectedReportLessonFilterType } = reportTypeManager;
      let reportId = ReportTypeService.getLessonFilterReportIdIfApplicable(selectedReportLessonFilterType);
      reportId = reportId || ReportIdentityService.getReportId(activeReportType, activeReportFacultyType);

      await reportIdentityManager.fetchReportResponseJson({
        courseId: courseContentItemId,
        failureBehaviorType: REPORT_FAILURE_BEHAVIOR_TYPE.FALLBACK_AND_FORCE_NO_DATA_STATE,
        reportId
      });
    } else {
      // user has changed the selected course, so `availableReportCourses` has also changed
      // here we need to update certain data to reflect the changes of `availableReportCourses`
      // (e.g. we need to update `hasSomeLikertReportData` and `hasSomeConventionalReportData`)
      const REPORT_COURSES = ReportJsonHelperService.REPORT_COURSES();

      const availableReportCourses = REPORT_COURSES.filter((reportCourse) => {
        return courseObj?.courseResourceId === reportCourse.courseId;
      });

      const hasLikert = !!availableReportCourses?.some?.((reportCourse) => {
        return reportCourse.hasLikert;
      });
      const hasConventional = !hasLikert || !!availableReportCourses?.some?.((reportCourse) => {
        return reportCourse.hasConventional;
      });

      reportIdentityManager.setHasSomeLikertReportData(hasLikert);
      reportIdentityManager.setHasSomeConventionalReportData(hasConventional);

      reportIdentityManager.setForceShowNoDataZeroState(false);
      ReportTableService.forceRerenderReportTable();
      ReportTypeService.initReportTableData();
    }
  };

  const renderReportCourseDropdown = () => {
    const { reportCourseDropdownOptions, selectedReportCourseContentItemId } = reportCourseManager;
    const { reportInfoClassNames } = reportIdentityManager;

    let placeholder;
    if (!reportCourseDropdownOptions.length) {
      placeholder = t('noCoursesToDisplay');
    } else {
      placeholder = t('selectCourse');
    }

    return (
      <div className={`report-dropdown report-course-dropdown ${reportInfoClassNames}`}>
        <div className='dropdown-label'>
          <div className='text'>
            {t('course')}
          </div>
        </div>
        <Dropdown
          disabled={!reportCourseDropdownOptions || (selectedReportCourseContentItemId && reportCourseDropdownOptions.length <= 1)}
          onChange={handleChangeReportCourseDropdown}
          options={reportCourseDropdownOptions}
          placeholder={t(placeholder)}
          search
          selectOnBlur={false}
          selectOnNavigation={false}
          selection
          value={selectedReportCourseContentItemId} />
      </div>
    );
  };
  return renderReportCourseDropdown();
});
export default ReportCourseDropdown;

SatCoreRegister('ReportCourseDropdown', ReportCourseDropdown);
